var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-empty',{staticClass:"custom-image",attrs:{"image":"https://img01.yzcdn.cn/vant/custom-empty-image.png","description":"敬请期待！！！"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }